// This file is autogenerated. Any changes will be overwritten.

export const set = 'streamline';

export const name = 'facebook';

export const Component = () => (
  <path
    fill='currentColor'
    d='M14.717 1.441c.517 0 .965.173 1.345.552.379.345.551.793.551 1.31v11.414c0 .517-.172.965-.551 1.345s-.828.551-1.345.551h-2.862v-5.448h2v-2.38h-2v-1.24c0-.346.172-.518.482-.518h1.517v-2.69h-1.69c-.862 0-1.586.31-2.172.965-.586.655-.896 1.414-.896 2.31v1.172H7.268v2.38h1.828v5.448h-5.76c-.517 0-.965-.172-1.344-.552a1.82 1.82 0 0 1-.552-1.344V3.302c0-.518.172-.965.552-1.31.379-.38.827-.552 1.345-.552h11.38z'
  />
);

export const viewBox = '0 0 18 18';
